export const teaching_data = {
    'es' : [
            {
                    'name'          : 'Entornos de enseñanza y aprendizaje mediados por tecnologías',
                    'effort'         : '4 horas',
                    'description'   : 'Este curso busca desarrollar habilidades para diseñar y gestionar actividades de aprendizaje mediadas por tecnologías, alineadas con objetivos pedagógicos y que fomenten la colaboración y autonomía de las y los estudiantes.',
                    'course_id'     : 'course-v1:eol+C2+2026_1',
                    'image'         : '/images/teaching/course-v1:eol+C2+2026_1.jpg',
                    'link'          : 'https://eol.uchile.cl/courses/course-v1:eol+C2+2026_1/about',
            },
            {
                    'name'          : 'Metodología, planificación y cubicación',
                    'effort'         : '8 horas',
                    'description'   : 'Este curso está enfocado en aplicar enfoques y herramientas para la planificación y cubicación de cursos de educación superior, optimizando los procesos de medición y organización en entornos mediados por tecnologías.',
                    'course_id'     : 'course-v1:eol+C4+2026_1',
                    'image'         : '/images/teaching/course-v1:eol+C4+2026_1.jpg',
                    'link'          : 'https://eol.uchile.cl/courses/course-v1:eol+C4+2026_1/about',
            },
            {
                    'name'          : 'Producción de material didáctico para entornos virtuales',
                    'effort'         : '6 horas',
                    'description'   : 'Este curso entrega orientaciones para implementar materiales didácticos multimedia, aplicando principios del diseño instruccional y asegurando su accesibilidad.',
                    'course_id'     : 'course-v1:eol+C5+2026_1',
                    'image'         : '/images/teaching/course-v1:eol+C5+2026_1.jpg',
                    'link'          : 'https://eol.uchile.cl/courses/course-v1:eol+C5+2026_1/about',
            },
            {
                    'name'          : 'Herramientas tecnológicas para la evaluación',
                    'effort'         : '4 horas',
                    'description'   : 'Este curso está orientado a conocer y aplicar tipos de evaluaciones efectivas y significativas, promoviendo el uso de herramientas virtuales coherentes que fortalezcan la enseñanza mediada por tecnologías.',
                    'course_id'     : 'course-v1:eol+C6+2026_1',
                    'image'         : '/images/teaching/course-v1:eol+C6+2026_1.jpg',
                    'link'          : 'https://eol.uchile.cl/courses/course-v1:eol+C6+2026_1/about',
            },
            {
                    'name'          : 'Herramientas para ayudantes en la educación mediada por tecnologías ',
                    'effort'         : '12 horas',
                    'description'   : 'Este curso está dedicado a guiar el trabajo de las y los ayudantes en la Plataforma EOL, de manera que puedan trabajar de manera autónoma en la conducción de un curso mediado por tecnologías.',
                    'course_id'     : 'course-v1:eol+HA+2025_1',
                    'image'         : '/images/teaching/course-v1:eol+HA+2025_1.jpg',
                    'link'          : 'https://eol.uchile.cl/courses/course-v1:eol+HA+2026_1/about',
            },
            
    ]
}
